export default function crystalData(){
  //水晶档位配置
  return [
    {
      crystalValue: 100,
      crystalNum: 300
    },
    {
      crystalValue: 75,
      crystalNum: 225
    },
    {
      crystalValue: 50,
      crystalNum: 150
    },
    {
      crystalValue: 25,
      crystalNum: 75
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/dispose.js